/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_ConvertInputs */

const en_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame Convert`)
};

const fr_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion drop frame`)
};

const de_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame Convert`)
};

const it_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversione a frame eliminato`)
};

const ru_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование кадров`)
};

const es_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversión de fotogramas eliminados`)
};

const zh_cn2_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧转换`)
};

const ja_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム変換`)
};

const hi_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम कन्वर्ट`)
};

const pt_pt2_dialogue_list_export_drop_frame_convert = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter quadro solto`)
};

/**
* | output |
* | --- |
* | "Drop Frame Convert" |
*
* @param {Dialogue_List_Export_Drop_Frame_ConvertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_convert = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_ConvertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_ConvertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "de") return de_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "it") return it_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "ru") return ru_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "es") return es_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "ja") return ja_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "hi") return hi_dialogue_list_export_drop_frame_convert(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_drop_frame_convert(inputs)
	return en_dialogue_list_export_drop_frame_convert(inputs)
});